import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './static-page-content.magic.css.js';
import script from './static-page-content.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'wrapper--top-nav': _vm.topNav, 'wrapper--headless': _vm.headless },attrs:{"part":_vm.$p('wrapper', { 'wrapper--top-nav': _vm.topNav })}},[(!_vm.page)?_c('magic-ui-loader',{staticClass:"loader",attrs:{"part":"loader"}}):_c('magic-ui-text',{ref:"text",staticClass:"text",attrs:{"is-markdown":"","content-text":"","part":"text","content":_vm.content},on:{"textLoad":function($event){return _vm.scrollToHash()}}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-449d1c83_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-449d1c83";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
